<template>
  <el-container class="content-width" style="flex-direction: column">
    <div class="introduce-text" style="margin: 30px 0">
      <p>
        The PROSCA provides an open assess online service enabling (1)
        automated-identification of scaffolds with innate low immunogenicity
        from a wide humanized protein space by using an extended structural
        alignment algorithm; (2) assessment of the target protein’s stability by
        the expression levels in human body based on the data in the map of the
        human tissue proteome; and (3) optional query of synthetic binding
        proteins (SBPs) for users using SBPs’ information collected in our
        <a href="http://synbip.idrblab.net/" target="_blank">SYNBIP</a>
        database.
        <b>Note:</b> You can submit or retrieve your mission through any of the
        three available methods.
      </p>
      <p>
        <b
          >The PROSCA is free and open to all users without login
          requirement.</b
        >
      </p>
    </div>

    <el-tabs v-model="activeName" @tab-click="handleClick" type="card">
      <el-tab-pane label="Submit a Protein Structure" name="first">
        <div style="height: 30px"></div>
        <el-form
          :label-position="labelPosition"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="" prop="pdb_text">
            <div class="input-title">Input Protein Structure (mandatory):</div>
            <div style="font-size: 20px">
              Please copy and paste your structure file here.
              <span class="input_example" @click="PDBexample()"># Example</span>
            </div>
            <el-input type="textarea" v-model="pdb_text" rows="6"></el-input>
            <div style="font-size: 20px">
              Or upload the structure file (Please upload the file with the
              suffix <b>pdb</b>. The file size should not exceed <b>5MB</b>):
            </div>
          </el-form-item>
          <el-upload
            class="upload-demo"
            style="margin-top: -20px"
            :action="upload_url"
            :on-exceed="handleExceed"
            :before-upload="beforeUpload"
            :on-success="uploadSuccess"
            :on-remove="handleRemove"
            :show-file-list="true"
            :limit="1"
            :file-list="fileList"
          >
            <el-button
              size="small"
              type="primary"
              class="btn-submit"
              style="font-size: 18px"
              >Click Upload</el-button
            >
          </el-upload>
          <div style="display: flex">
            <div style="font-size: 20px; width: 75%; margin-top: 6px">
              Please enter the protein chain for alignment (Enter if multiple
              chains exist in the file, otherwise skip):
            </div>
            <div style="font-size: 20px">
              <el-input v-model="pro_chain" placeholder="e.g., A"></el-input>
            </div>
          </div>

          <el-form-item label="" prop="pro_library">
            <div class="input-title">Select Protein Library (mandatory):</div>
            <div style="display: flex; justify-content: space-between">
              <el-select
                v-model="pro_library"
                filterable
                allow-create
                default-first-option
                placeholder="Please select structure type"
                style="width: 406px"
              >
                <el-option
                  v-for="item in protein_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                  <span style="float: left">{{ item.label }}</span>
                  <span style="float: right; color: #f56c6c; font-size: 13px">{{
                    item.hint
                  }}</span>
                </el-option>
              </el-select>
              <div style="font-size: 25px">>></div>
              <div v-if="pro_library == 'PDB' || pro_library == 'AlphaFold'">
                <el-select
                  v-model="pro_small_library"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="Please select the human protein structure library"
                  style="width: 699px"
                >
                  <el-option
                    v-for="item in protein_small_options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                    <span style="float: left">{{ item.label }}</span>
                    <span
                      style="float: right; color: #f56c6c; font-size: 13px"
                      >{{ item.hint }}</span
                    >
                  </el-option>
                </el-select>
              </div>
              <div v-else>
                <el-cascader
                  v-model="pro_small_library"
                  :options="protein_small_options"
                  :props="{ checkStrictly: true }"
                  placeholder="Please select the human protein structure library"
                  @change="changeCascader"
                  style="width: 699px; font-size: 20px"
                >
                  <template #default="{ node, data }">
                    <span style="float: left">{{ node.label }}</span>
                    <span
                      style="
                        float: right;
                        color: #f56c6c;
                        font-size: 13px;
                        padding-left: 10px;
                      "
                      >{{ data.hint }}</span
                    >
                    <!-- <span v-for="item,i in node" :key="i">{{ item }}</span> -->
                  </template>
                </el-cascader>
              </div>
            </div>
          </el-form-item>
          <div>
            Note: (1) If the amino acid length of the input protein is much
            longer than the target domain , no results will be outputted (TM
            &lt; 0.5). Please try to input short structures as much as possible.
            (2) When the amino acid length of the input protein is long or the
            user is uncertain about the length of the target domain, it is
            recommended to choose protein library grouped by family or
            containing all domains.
          </div>

          <el-form-item label="" prop="desc">
            <div class="input-title">Describe this mission (optional):</div>
            <el-input
              type="textarea"
              v-model="desc"
              rows="3"
              class="fs20"
            ></el-input>
          </el-form-item>

          <el-form-item label="" prop="email">
            <div class="input-title">
              Input email address (optional, used to send the result):
            </div>
            <el-input v-model="email" style="width: 46%"></el-input>
          </el-form-item>
          <el-form-item class="button-align">
            <el-button
              class="btn-submit"
              @click="submitForm()"
              style="font-size: 22px"
              >Submit</el-button
            >
            <el-button
              class="btn-submit"
              @click="resetForm()"
              style="font-size: 22px"
              >Reset</el-button
            >
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="Select a Synthetic Binding Protein" name="second">
        <div style="height: 30px"></div>

        <el-form
          :label-position="labelPosition"
          label-width="100px"
          class="demo-ruleForm"
        >
          <div class="input-title">SBP selection mode</div>
          <div style="display: flex; justify-content: space-between">
            <el-select
              v-model="SBP_selection_mode"
              filterable
              allow-create
              default-first-option
              style="width: 46%"
            >
              <el-option
                v-for="item in SBP_selection_mode_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div v-show="by_SBP_Name" class="input-title">
            Select SBP by SBP name:
          </div>
          <div
            v-show="by_SBP_Name"
            style="display: flex; justify-content: space-between"
          >
            <el-select
              v-model="SBP"
              filterable
              allow-create
              default-first-option
              placeholder="Please select a SBP"
              style="width: 100%"
            >
              <el-option
                v-for="item in SBP_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div v-show="by_Protein_Scaffold" class="input-title">
            Select SBP by protein scaffold:
          </div>
          <div
            v-show="by_Protein_Scaffold"
            style="display: flex; justify-content: space-between"
          >
            <el-select
              v-model="Protein_Scaffold"
              filterable
              allow-create
              default-first-option
              placeholder="Please select a protein scaffold"
              style="width: 46%"
            >
              <el-option
                v-for="item in Protein_Scaffold_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <div style="font-size: 25px">>></div>
            <el-select
              v-model="SBP"
              filterable
              allow-create
              default-first-option
              placeholder="Please select a SBP"
              style="width: 46%"
            >
              <el-option
                v-for="item in Protein_Scaffold_SBP_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div v-show="by_Target" class="input-title">
            Select SBP by target:
          </div>
          <div
            v-show="by_Target"
            style="display: flex; justify-content: space-between"
          >
            <el-select
              v-model="Target"
              filterable
              allow-create
              default-first-option
              placeholder="Please select a target"
              style="width: 46%"
            >
              <el-option
                v-for="item in Target_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <div style="font-size: 25px">>></div>
            <el-select
              v-model="SBP"
              filterable
              allow-create
              default-first-option
              placeholder="Please select a SBP"
              style="width: 46%"
            >
              <el-option
                v-for="item in Target_SBP_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>

          <br />

          <el-form-item label="" prop="pro_library">
            <div class="input-title">Select Protein Library (mandatory):</div>
            <div style="display: flex; justify-content: space-between">
              <el-select
                v-model="pro_library"
                filterable
                allow-create
                default-first-option
                placeholder="Please select structure type"
                style="width: 406px"
              >
                <el-option
                  v-for="item in protein_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                  <span style="float: left">{{ item.label }}</span>
                  <span style="float: right; color: #f56c6c; font-size: 13px">{{
                    item.hint
                  }}</span>
                </el-option>
              </el-select>
              <div style="font-size: 25px">>></div>
              <div v-if="pro_library == 'PDB' || pro_library == 'AlphaFold'">
                <el-select
                  v-model="pro_small_library"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="Please select the human protein structure library"
                  style="width: 699px"
                >
                  <el-option
                    v-for="item in protein_small_options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                    <span style="float: left">{{ item.label }}</span>
                    <span
                      style="float: right; color: #f56c6c; font-size: 13px"
                      >{{ item.hint }}</span
                    >
                  </el-option>
                </el-select>
              </div>
              <div v-else>
                <el-cascader
                  v-model="pro_small_library"
                  :options="protein_small_options"
                  :props="{ checkStrictly: true }"
                  placeholder="Please select the human protein structure library"
                  @change="changeCascader"
                  style="width: 699px; font-size: 20px"
                >
                  <template #default="{ node, data }">
                    <span style="float: left">{{ node.label }}</span>
                    <span
                      style="
                        float: right;
                        color: #f56c6c;
                        font-size: 13px;
                        padding-left: 10px;
                      "
                      >{{ data.hint }}</span
                    >
                    <!-- <span v-for="item,i in node" :key="i">{{ item }}</span> -->
                  </template>
                </el-cascader>
              </div>
            </div>
          </el-form-item>
          <div>
            Note: (1) If the amino acid length of the input protein is much
            longer than the target domain , no results will be outputted (TM
            &lt; 0.5). Please try to input short structures as much as possible.
            (2) When the amino acid length of the input protein is long or the
            user is uncertain about the length of the target domain, it is
            recommended to choose protein library grouped by family or
            containing all domains.
          </div>
          <el-form-item label="" prop="desc">
            <div class="input-title">Describe this mission (optional):</div>
            <el-input
              type="textarea"
              v-model="desc"
              rows="3"
              class="fs20"
            ></el-input>
          </el-form-item>

          <el-form-item label="" prop="email">
            <div class="input-title">
              Input email address (optional, used to send the result):
            </div>
            <el-input v-model="email" style="width: 46%"></el-input>
          </el-form-item>
          <el-form-item class="button-align">
            <el-button
              class="btn-submit"
              @click="submitSYNBIP()"
              style="font-size: 22px"
              >Submit</el-button
            >
            <el-button
              class="btn-submit"
              @click="resetSYNBIP()"
              style="font-size: 22px"
              >Reset</el-button
            >
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="Retrieve a History Alignment" name="third">
        <div style="height: 30px"></div>
        <el-form
          :label-position="labelPosition"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="" prop="email">
            <div class="input-title">
              Input Mission ID (mandatory):
              <span
                class="input_example"
                @click="Historyexample()"
                style="font-weight: normal"
                ># Example</span
              >
            </div>
            <el-input v-model="submitHistory" style="width: 600px"></el-input>
          </el-form-item>

          <el-form-item class="button-align">
            <el-button
              class="btn-submit"
              @click="submitHis()"
              style="font-size: 22px"
              >Submit</el-button
            >
            <el-button
              class="btn-submit"
              @click="resetHis()"
              style="font-size: 22px"
              >Reset</el-button
            >
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>

    <div style="display: flex; flex-direction: row; justify-content: flex-end">
      <!-- <div ref="counterContainer"></div> -->
      <div style="font-weight: bold;">{{visit_num}}</div>
      <div style="padding-left: 10px;">visits since 2024</div>
    </div>
  </el-container>
</template>




<script>
import api from "../../api/index";
import pathUrl from "../../api/path";
// import DivUnit from "@/components/DivUnit.vue";
export default {
  data: () => ({
    random_num: Math.floor(Math.random() * (9999 - 1000)) + 1000,
    mission_id: "",
    activeName: "first",
    labelPosition: "top",
    fileList: [],
    upload_url: "",
    upload_str: "",
    pro_chain: "",
    protein_options: [
      {
        value: "AlphaFold",
        label: "AlphaFold Structure",
        hint: "Group by Family",
      },
      {
        value: "PDB",
        label: "PDB Structure",
        hint: "Group by Family",
      },
      {
        value: "AlphaFold_Domain",
        label: "AlphaFold Structure",
        hint: "Group by Domain",
      },
      {
        value: "PDB_Domain",
        label: "PDB Structure",
        hint: "Group by Domain",
      },
    ],
    protein_small_options: "",
    protein_2_options: {},
    // ruleForm: {
    pdb_text: "",
    pro_library: "",
    pro_small_library: "",
    desc: "",
    email: "",
    // },
    // pro_library: "",
    submitHistory: "",
    // rules: {
    //   pdb_text: [{ required: false, trigger: "blur" }],
    //   pro_library: [{ required: false, trigger: "blur" }],
    //   desc: [{ required: false, trigger: "blur" }],
    //   email: [{ required: false, trigger: "blur" }],
    // },
    SBP_selection_mode: "Select SBP by protein scaffold",
    SBP_selection_mode_options: [
      {
        value: "Select SBP by SBP name",
        label: "Select SBP by SBP name",
      },
      {
        value: "Select SBP by protein scaffold",
        label: "Select SBP by protein scaffold",
      },
      {
        value: "Select SBP by target",
        label: "Select SBP by target",
      },
    ],

    by_SBP_Name: false,
    by_Protein_Scaffold: true,
    by_Target: false,
    SBP: "",
    SBP_options: [],
    Target: "",
    Target_options: [],
    // Target_SBP: "",
    Target_SBP_options: [],
    Protein_Scaffold: "",
    Protein_Scaffold_options: [],
    // Protein_Scaffold_SBP: "",
    Protein_Scaffold_SBP_options: [],
    SBPdata: "",

    visit_num: "",
  }),
  components: {
    // DivUnit,
  },
  watch: {
    // ruleForm: {
    //   handler: function (o) {
    //     this.pro_library = o.pro_library;
    //     console.log(this.pro_library);
    //   },
    //   deep: true,
    // },
    pro_library: {
      handler: function (o) {
        console.log(o);
        this.protein_small_options = this.protein_2_options[o];
        // console.log(this.protein_2_options[o][0].value);
        // this.pro_small_library = [
        //   this.protein_2_options[o][3].value,
        // ];
      },
      deep: true,
    },
    Target: {
      handler: function (o) {
        console.log(o);
        this.Target_SBP_options = this.SBPdata.Target_SBP[o];
        // console.log(this.protein_2_options[o][0].value);
      },
      deep: true,
    },
    Protein_Scaffold: {
      handler: function (o) {
        console.log(o);
        this.Protein_Scaffold_SBP_options = this.SBPdata.Scaffold_SBP[o];
        // console.log(this.protein_2_options[o][0].value);
      },
      deep: true,
    },
    SBP_selection_mode: {
      handler: function (o) {
        this.SBP = "";
        this.Protein_Scaffold = "";
        this.Target = "";
        this.by_SBP_Name = false;
        this.by_Protein_Scaffold = false;
        this.by_Target = false;
        console.log(o);
        if (o == "Select SBP by SBP name") {
          this.by_SBP_Name = true;
        } else if (o == "Select SBP by protein scaffold") {
          this.by_Protein_Scaffold = true;
        } else {
          this.by_Target = true;
        }
        // console.log(this.protein_2_options[o][0].value);
      },
      deep: true,
    },
  },
  methods: {
    PDBexample() {
      // xhr.responseText为文本中的内容
      let xhr = new XMLHttpRequest();
      xhr.open("GET", "example.pdb", false); // public文件夹下的绝对路径
      xhr.overrideMimeType("text/html;charset=utf-8");
      xhr.send(null);
      this.pdb_text = xhr.responseText;
      // xhr.responseText为文本中的内容
      this.pro_library = "AlphaFold";
      this.pro_small_library = "Immunoglobulin superfamily";
      this.desc = "example";
      this.pro_chain = "";
    },
    Historyexample() {
      this.submitHistory = "61661702194919633";
    },
    handleExceed() {
      this.$notify({
        title: "Warning",
        message: `Delete the old file before uploading the new file.`,
        type: "warning",
        duration: 10000,
      });
    },
    beforeUpload(file) {
      var isLt3M = Number(file.size / 1024 / 1024) > 3;
      var FileExt = file.name.replace(/.+\./, "");
      if (["pdb"].indexOf(FileExt.toLowerCase()) === -1) {
        this.$notify({
          title: "Warning",
          type: "warning",
          message: "Please upload the file with the suffix pdb",
          duration: 10000,
        });
        return false;
      }
      if (isLt3M) {
        this.$notify({
          title: "Warning",
          type: "warning",
          message: "The file size should not exceed 5MB",
          duration: 10000,
        });
        return false;
      }
    },
    uploadSuccess(response) {
      this.upload_str = response.random_str;
    },
    handleRemove() {
      this.upload_str = "";
    },
    submitForm() {
      var pdb_text_check = this.pdb_text.trim() != "";
      var upload_check = this.upload_str != "";
      var pro_library_check = this.pro_small_library != "";
      if ((pdb_text_check || upload_check) && pro_library_check) {
        this.mission_id = "" + this.random_num + new Date().getTime();
        console.log(this.pro_small_library);
        var post_data = {
          pdb_text: this.pdb_text,
          pro_library: this.pro_library,
          pro_small_library: this.pro_small_library,
          desc: this.desc,
          email: this.email,
          mission_id: this.mission_id,
          upload_str: this.upload_str,
          pro_chain: this.pro_chain,
        };
        console.log(post_data);
        api.postAlignment(post_data).then((res) => {
          console.log(res);
        });
        // api.getAlignment(this.mission_id).then((res) => {
        //   console.log(res.data);
        // });
        this.$router.push("/job?id=" + this.mission_id);
      } else {
        this.$alert(
          '<b style="color:#fe6c6f">Protein Structure</b> and <b style="color:#fe6c6f">Protein Library</b> are Mandatory',
          "Error",
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "Close",
          }
        );
      }
    },
    resetForm() {
      this.pdb_text = "";
      this.pro_library = "";
      this.pro_small_library = [];
      this.desc = "";
      this.email = "";
    },
    submitSYNBIP() {
      var SYNBIP_check = this.SBP != "";
      var pro_library_check = this.pro_small_library != "";
      if (SYNBIP_check && pro_library_check) {
        this.mission_id = "" + this.random_num + new Date().getTime();

        var post_data = {
          SYNBIP_id: this.SBP,
          pro_library: this.pro_library,
          pro_small_library: this.pro_small_library,
          desc: this.desc,
          email: this.email,
          mission_id: this.mission_id,
        };
        api.postAlignmentSYNBIP(post_data).then((res) => {
          console.log(res);
        });
        this.$router.push("/job?id=" + this.mission_id);
      } else {
        this.$alert(
          '<b style="color:#fe6c6f">SBP</b> and <b style="color:#fe6c6f">Protein Library</b> are Mandatory',
          "Error",
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "Close",
          }
        );
      }
    },
    resetSYNBIP() {
      this.SBP = "";
      this.Protein_Scaffold = "";
      this.Target = "";
      this.pro_library = "";
      this.pro_small_library = [];
      this.desc = "";
      this.email = "";
    },
    submitHis() {
      api.getCheckMissionID(this.submitHistory).then((res) => {
        if (res.data.result) {
          this.$router.push("/job?id=" + this.submitHistory);
        } else {
          this.$alert(
            "The mission ID is invalid. Please enter the correct mission ID",
            "Warning",
            {
              dangerouslyUseHTMLString: true,
              confirmButtonText: "Close",
            }
          );
        }
      });
    },
    resetHis() {
      this.submitHistory = "";
    },
    changeCascader(node) {
      console.log(node);
    },
  },
  beforeMount() {
    this.upload_url = pathUrl.baseUrl + "/analyze/postfile";
    api.getProteinLibrary().then((res) => {
      this.protein_2_options = res.data.protein_2_options;

      this.pro_library = "AlphaFold";
      this.protein_small_options = this.protein_2_options[this.pro_library];
      // console.log();
    });
  },
  mounted() {
    api.getSYNBIP().then((res) => {
      // this.protein_2_options = res.data.protein_2_options;
      this.Target_options = res.data.SYNBIP.Target_list;
      this.Protein_Scaffold_options = res.data.SYNBIP.Scaffold_list;
      this.SBP_options = res.data.SYNBIP.SBP_list;
      this.SBPdata = res.data.SYNBIP;

      this.Protein_Scaffold = "ABD-derived affinity protein";
      this.Protein_Scaffold_SBP_options =
        this.SBPdata.Scaffold_SBP[this.Protein_Scaffold];
    });
    
    api.getVisitors().then((res) => {
      // this.protein_2_options = res.data.protein_2_options;
      console.log(res.data);
      this.visit_num = res.data.visit_num;
    });

    // 创建 script 标签
    const script = document.createElement("script");
    script.language = "javascript";
    script.src = "http://www.hitcounters.net/counter.php?id=11805&cmd=cookie";

    // 创建 img 标签
    const img = document.createElement("img");
    img.src = "http://www.hitcounters.net/counter.php?id=11805&cmd=img_only";
    img.alt = "insurancedirectory.org";
    img.border = "0";

    // 将元素插入到容器中
    this.$refs.counterContainer.appendChild(script);
    this.$refs.counterContainer.appendChild(img);
  },
};
</script>
<style>
.el-tabs__item.is-active {
  border: 4px solid #5181c6;
  background: #5181c6 !important;
  border-bottom-color: #5181c6 !important;
  color: #fff !important;
}
.el-tabs__content {
  position: relative;
  border: 4px solid #5181c6;
  padding: 0 25px;
  border-radius: 0 0 5px 5px;
  box-shadow: 7px 6px 11px 0px #cbcaca;
  margin-bottom: 30px;
  border-top: 0px solid #5181c6;
}
.el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0;
  box-shadow: 7px 0px 11px 0px #cbcaca;
}
.el-tabs__nav > div {
  width: 33.33%;
  text-align: center;
  display: flex;
  font-size: 20px;
  font-weight: bold;
  height: 50px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  cursor: pointer;
  flex-direction: column;
  justify-content: space-around;
  background: #f1f1f1;
  border: 1px solid #5181c6;
  border-left: 1px solid #5181c6 !important;
  border-bottom: 4px solid #5181c6 !important;
  color: #706e6e;
  box-shadow: 0px 0px 0px 0px #a5a5a5;
}
.el-tabs__nav > div:hover {
  background: #91afdb;
  color: #fff;
}
.el-tabs__item.is-active,
.el-tabs__item:hover {
  color: #fff;
}
.el-tabs__nav {
  border: 0 !important;
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.input_example {
  color: #ff9800;
  cursor: pointer;
}
.input_example:hover {
  text-decoration: underline;
}
.input-title {
  font-size: 22px;
  font-weight: bold;
  color: #5181c6;
  margin-top: 20px;
}
.el-form-item__label {
  font-size: 22px;
  font-weight: bold;
  color: #5181c6;
}
.el-tabs__item {
  font-size: 22px;
  font-weight: bold;
}
.el-tabs__item.is-active,
.el-tabs__item.is-active,
.el-tabs__item:hover {
  color: #ed862a;
}
.el-tabs__active-bar {
  background-color: #ed862a;
  height: 3px;
}
.el-tabs__nav-scroll {
  display: flex;
  justify-content: space-around;
}
.el-tabs__nav-wrap::after {
  width: auto;
}
.introduce-text {
  padding: 16px;
  background: #c55a111f;
  border-radius: 10px;
  font-size: 20px;
  box-shadow: 7px 6px 11px 0px #cbcaca;
  line-height: 1.8;
}
.introduce-text-SYNBIP {
  margin: 30px 0;
  padding: 16px;
  background: #f0f8ff;
  border-radius: 10px;
  font-size: 20px;
  line-height: 1.8;
}
.btn-submit {
  font-size: 20px;
  background: #5181c6;
  color: #fff;
}
.btn-submit:hover,
.btn-submit:active,
.btn-submit:focus {
  background: #6699e0;
  color: #fff;
}
.btn-submit2 {
  font-size: 20px;
  background: #ed862a;
  color: #fff;
}
.btn-submit2:hover,
.btn-submit2:active,
.btn-submit2:focus {
  background: #dd8e48;
  color: #fff;
}
.el-upload-list {
  width: 50%;
}
.button-align {
  display: flex;
  justify-content: space-around;
  margin-top: 50px;
}
.el-notification {
  width: 400px;
  background: #ffeaa5;
}
.el-message-box__title {
  font-size: 20px;
  font-weight: bold;
}

.el-cascader-panel {
  font-size: 20px;
}
.el-radio__input.is-disabled .el-radio__inner {
  display: none;
}
</style>